import { createFileRoute } from "@tanstack/react-router"

import { PlaceholderPanel } from "@/components/shared/PlaceholderPanel"

export const Route = createFileRoute("/agents/reviews")({
  component: () => (
    <PlaceholderPanel
      title="Quality Review Queue"
      description="Prioritized 6-step review wizard: Test Prompts → Baseline → Hallucination → Knowledge → Scoring → Submit"
    />
  ),
})
